// extracted by mini-css-extract-plugin
module.exports = {"buttonAlignCenter":"Button_buttonAlignCenter__EgbRu","buttonAlignRight":"Button_buttonAlignRight__38da0"};